import { useTheme } from "@mui/material/styles";
import { ReactComponent as HelpCircleIcon } from "components/Icons/help-circle.svg";
import { ExternalLinkTooltipContent } from "components/Tooltips/ExternalLinkTooltip";
import { Tooltip } from "components/Tooltips/Tooltip";
import { DonutChart } from "components/UsersPercentageChart/DonutChart";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";
import { Total } from "types/listing";
import { formatNumberValue } from "utilities/numbers";
import { useStyles } from "./styles";
import { countPercentage } from "./utils";

interface Props {
  donutLabel?: string;
  total: Total;
}

export const Donut = ({ total, donutLabel }: Props) => {
  const classes = useStyles();
  const { message } = useMessage();
  const theme: OLTheme = useTheme();

  return (
    <div className={classes.chartDataContainer}>
      <div className={classes.donutChart}>
        <DonutChart
          data={[
            {
              color: theme.primary500,
              id: "1",
              label: "1",
              value: countPercentage(total.filtered!, total.all!),
            },
            {
              color: theme.primary200,
              id: "2",
              label: "2",
              value: 100 - countPercentage(total.filtered!, total.all!),
            },
          ]}
          isInteractive={false}
          innerRadius={0.5}
        />
      </div>
      <p className={classes.donutChartDescription}>
        <span className={classes.bolder}>
          {`${formatNumberValue(total.filtered)} (${countPercentage(
            total.filtered!,
            total.all!,
          )}%)`}
        </span>{" "}
        <span>{message({ id: "of" })} </span>
        <span className={classes.bolder}>
          {formatNumberValue(total?.all)}
        </span>{" "}
        <span>{donutLabel && donutLabel}</span>
      </p>
      {total?.estimated && (
        <Tooltip
          text={
            <ExternalLinkTooltipContent
              externalLink="https://help.openloyalty.io/main-features/members/member-list#list-of-members-overview"
              name="estimatedResults"
              text={message({ id: "estimatedResultsInfo" })}
            />
          }
        >
          <HelpCircleIcon className={classes.tooltipInTable} />
        </Tooltip>
      )}
    </div>
  );
};
